import styled from "styled-components";

export const InfoCont = styled.div(
  (props) => `
    height: 2.8rem;
    background-color: ${props?.bgc ? props.bgc : '#fffff1'};
    display: flex;
    align-items: center;
    justify-content: center;
    p{
        paddign: 0.1rem;
        font-size: 1.4rem;
        line-height: 1.8rem;
        font-weight: 600;
        color: ${props?.tc ? props.tc : props.theme.colors.shadow.dark};
    }
`
);
